import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable, map } from 'rxjs'
import { Store } from '@ngrx/store'
import { ServiceUrlConstants } from 'src/constants/service-url-constants'
import { AppState } from 'src/store/state/app.state'
import { Expense, ExpenseReportAPIModel, ListExpenseAPIRequest, PaginatedAPI } from 'src/models/api.model'
import { getExpenseReport, getExpenses } from 'src/store/selector/expense.selector'
import { CLEAR_EXPENSES } from 'src/store/action/expense.action'

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  getExpenseReportFromStore = (): Observable<PaginatedAPI<ExpenseReportAPIModel>> => {
    return this.appState.select(getExpenseReport())
  }

  callGetExpenseReportApi = ({ payload }) => {
    const url = `${ServiceUrlConstants.API_EXPENSE_REPORT_LIST}?pageNo=${payload.pageInfo.pageNo}&limit=${payload.pageInfo.limit}&sortBy=${payload.sort.sortBy}&sortOrder=${payload.sort.sortOrder}`
    return this.webservice.post(url, payload.filters).pipe(map((data: PaginatedAPI<ExpenseReportAPIModel>) => data))
  }

  getExpensesFromStore = (): Observable<PaginatedAPI<Expense>> => {
    return this.appState.select(getExpenses())
  }

  callGetExpensesApi = ({ payload }) => {
    const url = `${ServiceUrlConstants.API_EXPENSE_LIST}?pageNo=${payload.pageInfo.pageNo}&limit=${payload.pageInfo.limit}&sortBy=${payload.sort.sortBy}&sortOrder=${payload.sort.sortOrder}`
    return this.webservice.post(url, payload.filters).pipe(map((data: PaginatedAPI<Expense>) => data))
  }

  dispatchClearExpensesFromStore = () => {
    return this.appState.dispatch(CLEAR_EXPENSES())
  }
}
